// extracted by mini-css-extract-plugin
export default {"title":"header-with-text-template_title__IpAPY","text":"header-with-text-template_text__CuiIy","TimelineItemHeaderText":"header-with-text-template_TimelineItemHeaderText__rw6cy"};